"use client";
import LogoWithTitle from "./components/logo-title";
import FlexRowCenter from "@/components/flex-box/flex-row-center";
import { Wrapper } from "./styles";

export default function AuthLayout({
  children,
  bottomContent
}) {
  return <FlexRowCenter flexDirection="column" minHeight="100vh" px={2}>
    <Wrapper elevation={6}>
      <LogoWithTitle />
      {children}
      {bottomContent}
    </Wrapper>
  </FlexRowCenter>;
}